import type { IdentityProfile, IdentityProvider } from "./IdentityProvider";

const STORAGE_KEY = "audio-form:userId";
const DISPLAY_NAME_KEY = "audio-form:displayName";

// localStorage はブラウザ設定や社内ポリシーでアクセス自体が例外を投げることがある
// (社内向け PoC の対象読者では現実的に起こりうる)。読み書きの失敗をここで握りつぶし
// 「未保存」として扱うことで、呼び出し元 (getUserId 等) を reject させない
// (原則 5: fire-and-forget、UI をブロック/破壊しない)。
function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // 保存できなくても致命的にしない: 値は今回のロード内でのみ有効になる
  }
}

export class AnonymousIdentityProvider implements IdentityProvider {
  async getUserId(): Promise<string> {
    const existing = readStorage(STORAGE_KEY);
    if (existing) return existing;
    const id = crypto.randomUUID();
    writeStorage(STORAGE_KEY, id);
    return id;
  }

  async getProfile(): Promise<IdentityProfile> {
    const userId = await this.getUserId();
    const displayName = readStorage(DISPLAY_NAME_KEY);
    return displayName ? { userId, displayName } : { userId };
  }

  async setDisplayName(name: string): Promise<void> {
    const trimmed = name.trim();
    if (!trimmed) return;
    writeStorage(DISPLAY_NAME_KEY, trimmed);
  }
}
